document.addEventListener("DOMContentLoaded", function () {
  // ✅ Apne variant IDs yahan daalo
  const variantA = "3615148605699"; // 1-10
  const variantB = "3615148638467"; // 11-50
  const variantC = "3615148671235"; // 51-500

  // Quantity input
  const qtyInput = document.querySelector('[id^="Quantity-template--"]');
  if (!qtyInput) return;

  // Variant switcher logic
  function handleQtyChange(qty) {
    let targetId = variantA;
    if (qty >= 11 && qty <= 50) targetId = variantB;
    if (qty >= 51) targetId = variantC;

    const radio = document.querySelector(
      `input[type="radio"][data-option-value-id="${targetId}"]`
    );

    if (radio) {
      const label = document.querySelector(`label[for="${radio.id}"]`);
      if (label) {
        label.click(); // trigger theme’s native variant selector
        console.log("✅ Variant switched:", targetId);
      }
    }
  }

  // Input typing
  qtyInput.addEventListener("change", e => {
    const qty = parseInt(e.target.value, 10);
    if (!isNaN(qty)) handleQtyChange(qty);
  });

  // Plus/Minus buttons
  document.querySelectorAll('button[name="plus"], button[name="minus"]').forEach(btn => {
    btn.addEventListener("click", () => {
      setTimeout(() => {
        const qty = parseInt(qtyInput.value, 10);
        if (!isNaN(qty)) handleQtyChange(qty);
      }, 50);
    });
  });
});
